// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { SectorisationArgs_abstract } from './../../abstract/SagaBase/Defines/SectorisationArgs_abstract';
export class SectorisationArgs extends SectorisationArgs_abstract {}
